import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { UserDocument } from "../../existing-chat/models/UserDocument";

export const useGetDocument = () => {
  const {
    data: document,
    call,
    isLoading,
  } = useApiPrivateRequest<UserDocument>(
    (response) => new UserDocument(response),
  );
  const getDocument = async (documentId: string) => {
    await call(`/documents/${documentId}`, "GET");
  };

  return { document, getDocument, isLoading };
};
